module.exports = __webpack_public_path__ + "img/KellyPalmer.68e69fcd.jpg";